import useFormat from "../../hooks/useFormat";

const CheckoutPayments = ({ promoAppliedValue, summary }) => {

    const { formatPrice } = useFormat();

    const calcTotal = () => {
        let total = summary?.total_net - promoAppliedValue;
        return formatPrice(total);
    };
    return (
        <>            
            {summary && (
                <div>
                    <div className=" rounded-8 p-24">
                        <div className="mb-32 flex-between gap-8">
                            <span className="text-gray-900 font-heading-two">Subtotal</span>
                            <span className="text-gray-900 fw-semibold">{ formatPrice(summary?.total_gross) }</span>
                        </div>
                        <div className="mb-32 flex-between gap-8">
                            <span className="text-gray-900 font-heading-two">
                                VAT
                            </span>
                            <span className="text-gray-900 fw-semibold">{ formatPrice(summary?.total_net - summary?.total_gross) }</span>
                        </div>
                        <div className="mb-32 flex-between gap-8">
                            <span className="text-gray-900 font-heading-two">
                                Shipping
                            </span>
                            <span className="text-gray-900 fw-semibold">{ formatPrice(0) }</span>
                        </div>
                        <div className="mb-32 flex-between gap-8">
                            <span className="text-gray-900 font-heading-two">
                                Promotion applied
                            </span>
                            <span className="text-gray-900 fw-semibold">{ formatPrice(promoAppliedValue) }</span>
                        </div>                            
                    {/* </div>   
                    <div className="border border-gray-100 rounded-8 p-24"> */}
                        <div className="flex-between gap-8">
                            <span className="text-gray-900 text-2xl fw-semibold">Total</span>
                            <span className="text-gray-900 text-xl fw-semibold">{ calcTotal() }</span>
                        </div>
                    </div>
                </div>
            )} 
        </>
    );
};

export default CheckoutPayments;
